module.exports = __webpack_public_path__ + "static/media/PersonPic.7a06d2db.png";